import { h } from 'preact';
import React, { Component } from 'react';

import { Sanitize } from '../Sanitize/Sanitize';
import { formatDescription } from '../../util';

import './Stacks.css';

export default class Accordion extends Component {
  state = {
    open: false
  }
  toggleAccordion = () => {
    const panel = this.panel;
    const open = !this.state.open;
    this.setState({ open })
  }

  render() {
    const { stack, loading } = this.props;
    const { open } = this.state;
    const description = (stack.type === 'CUSTOM')
      ? (
        <p
          style={{ ...this.props.panelStyles }}
          dangerouslySetInnerHTML={{ __html: Sanitize({ html: stack.description }) }}
        />
      )
      : (
        <p style={{ ...this.props.panelStyles }}>
          {formatDescription(stack.description)}
        </p>
      );

    return (
      <div className="stack">
        <button
          className={open ? 'accordion active' : 'accordion'}
          style={this.props.accordionStyles}
          aria-expanded={open ? 'true' : 'false'}
          onClick={loading ? null : this.toggleAccordion}
        >
          {stack.name}
          {loading ? null : <span className={open ? 'chevron up' : 'chevron down'} />}
        </button>
        <div
          style={{ display: open ? 'block' : 'none' }}
          className="panel"
          aria-hidden={open ? 'false' : 'true'}
        >
          {description}
        </div>
      </div>
    );
  }
}
